import type { CardDesign, Rarity, Sport } from '__generated__/globalTypes';
import type { LineupStyle } from 'components/lobby/ContenderLayout';

import { local } from '.';

export enum SportSelectType {
  ALL_SPORTS = 'allSport',
  FOOTBALL = 'football',
  BASEBALL = 'baseball',
  NBA = 'nba',
}

export const LocalKeys = {
  test: 'test',
  showOnlyGamesWithLinedUpPlayers: 'showOnlyGamesWithLinedUpPlayers',
  sortingOrderSchedule: 'sortingOrderSchedule',
  includeCommonsSchedule: 'includeCommonsSchedule',
  mlbGameViewStats: 'mlbGameViewStats',
  savedHistory: 'savedHistory',
  trackingConsent: 'trackingConsent',
  mlbMonthlyChaseLastPreferredScarcity: 'mlbMonthlyChaseLastPreferredScarcity',
  useRedDotNotification: 'useRedDotNotification',
  useBaseballRedDotNotification: 'useBaseballRedDotNotification',
  useNbaRedDotNotification: 'useNbaRedDotNotification',
  sportLineupStyle: 'sportLineupStyle',
  mlbOffseasonCountdownReminder: 'mlbOffseasonCountdownReminder',
  sport: 'sport',
  lastVisitedEventType: 'lastVisitedEventType',
  navigationSidebarCollapsed: 'navigationSidebarCollapsed',
  myBidsBannerIgnoredBids: 'myBidsBannerIgnoredBids',
  expandLiveEvent: 'expandLiveEvent',
  device_fingerprint: 'DEVICE_FINGERPRINT',
  randomSessionId: 'randomSessionId',
  selectedSport: 'selectedSport',
  selectedDesign: 'selectedDesign',
  cardEditionName: 'cardEditionName',
  gqlDebug: 'gql-debug',
  mySorareSelectedSport: 'MySorare.selectedSport',
  arenaRarityFilter: 'arenaRarityFilter',
  referrer: 'REFERRER',
  impact_clickid: 'IMPACT_CLICKID',
  google_clickid: 'GOOGLE_CLICKID',
  facebook_clickid: 'FACEBOOK_CLICKID',
  twitter_clickid: 'TWITTER_CLICKID',
  tiktok_clickid: 'TIKTOK_CLICKID',
  snapchat_clickid: 'SNAPCHAT_CLICKID',
  reddit_clickid: 'REDDIT_CLICKID',
  invitation_token: 'INVITATION_TOKEN',
  utm_source: 'UTM_SOURCE',
  utm_medium: 'UTM_MEDIUM',
  utm_campaign: 'UTM_CAMPAIGN',
  utm_term: 'UTM_TERM',
  utm_content: 'UTM_CONTENT',
  custom_profile_id: 'CUSTOM_PROFILE_ID',
  traffic_category: 'TRAFFIC_CATEGORY',
  partner: 'PARTNER',
  user: 'USER',
} as const;

export type LocalStorageEntries = {
  [LocalKeys.test]: any; // any on purpose for testing any values
  [LocalKeys.showOnlyGamesWithLinedUpPlayers]: any;
  [LocalKeys.sortingOrderSchedule]: any;
  [LocalKeys.includeCommonsSchedule]: any;
  [LocalKeys.mlbGameViewStats]: 'fantasy' | 'actual';
  [LocalKeys.savedHistory]: any;
  [LocalKeys.trackingConsent]: boolean;
  [LocalKeys.mlbMonthlyChaseLastPreferredScarcity]: any;
  [LocalKeys.useRedDotNotification]: any;
  [LocalKeys.useBaseballRedDotNotification]: any;
  [LocalKeys.useNbaRedDotNotification]: any;
  [LocalKeys.sportLineupStyle]: Record<Sport, LineupStyle>;
  [LocalKeys.mlbOffseasonCountdownReminder]: any;
  [LocalKeys.sport]: Sport | undefined;
  [LocalKeys.lastVisitedEventType]: any;
  [LocalKeys.navigationSidebarCollapsed]: boolean;
  [LocalKeys.myBidsBannerIgnoredBids]: string[];
  [LocalKeys.expandLiveEvent]: boolean;
  [LocalKeys.device_fingerprint]: string;
  [LocalKeys.randomSessionId]: string;
  [LocalKeys.selectedSport]: 'football' | 'baseball' | 'nba';
  [LocalKeys.selectedDesign]: CardDesign;
  [LocalKeys.cardEditionName]: string;
  [LocalKeys.gqlDebug]: boolean;
  [LocalKeys.mySorareSelectedSport]: SportSelectType;
  [LocalKeys.arenaRarityFilter]: Rarity;
  [LocalKeys.referrer]: string;
  [LocalKeys.impact_clickid]: string;
  [LocalKeys.google_clickid]: string;
  [LocalKeys.facebook_clickid]: string;
  [LocalKeys.twitter_clickid]: string;
  [LocalKeys.tiktok_clickid]: string;
  [LocalKeys.snapchat_clickid]: string;
  [LocalKeys.reddit_clickid]: string;
  [LocalKeys.invitation_token]: string;
  [LocalKeys.utm_source]: string;
  [LocalKeys.utm_medium]: string;
  [LocalKeys.utm_campaign]: string | number | undefined;
  [LocalKeys.utm_term]: string;
  [LocalKeys.utm_content]: string;
  [LocalKeys.custom_profile_id]: string;
  [LocalKeys.traffic_category]: string;
  [LocalKeys.partner]: string;
  [LocalKeys.user]: string;
};
export const localStorage = {
  getItem: <K extends keyof LocalStorageEntries>(value: K) =>
    local.getItem(value) as LocalStorageEntries[K],
  setItem: <K extends keyof LocalStorageEntries>(
    key: K,
    value: LocalStorageEntries[K] | null
  ) => local.setItem(key, value),
  removeItem: <K extends keyof LocalStorageEntries>(key: K) =>
    local.removeItem(key),
  key: (index: number) => local.key(index),
  length: local.length,
  clear: local.clear,
};
